var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#414141;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reports_active",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,46.5C40,46.5,40,46.5,40,46.5H5.8c-3.2,0-5.8-2.6-5.8-5.8V5.4c0-3.2,2.6-5.8,5.8-5.8h26.9 c0.5,0,1,0.2,1.3,0.5l11.2,10.8c0.4,0.4,0.6,0.9,0.6,1.4v28.4C45.8,43.8,43.2,46.4,40,46.5z M5.8,3.4c-1.1,0-1.9,0.9-1.9,1.9v35.3 c0,1.1,0.9,1.9,1.9,1.9H40c1.1,0,1.9-0.9,1.9-1.9V13.1l-10-9.7H5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44,14.7H32.5c-1.1,0-1.9-0.9-1.9-1.9V1.5c0-1.1,0.9-1.9,1.9-1.9c1.1,0,1.9,0.9,1.9,1.9v9.3H44 c1.1,0,1.9,0.9,1.9,1.9S45.1,14.7,44,14.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9_00000098907656719883923650000013995862575461716399_",
    className: "st0",
    d: "M19.4,36.3c-5.3,0-9.7-4.3-9.7-9.7 S14,17,19.4,17v9.7h9.7C29,32,24.7,36.3,19.4,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.4,38.2C19.4,38.2,19.4,38.2,19.4,38.2C13,38.2,7.8,33,7.8,26.6S13,15,19.4,15c1.1,0,1.9,0.9,1.9,1.9v7.7 h7.7c0.5,0,1,0.2,1.4,0.6c0.4,0.4,0.6,0.9,0.6,1.4C31,33,25.8,38.2,19.4,38.2z M17.4,19.1c-3.3,0.9-5.8,3.9-5.8,7.5 c0,4.3,3.5,7.7,7.7,7.7c3.6,0,6.6-2.5,7.5-5.8h-7.5c-1.1,0-1.9-0.9-1.9-1.9V19.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.9,28.6H19.4c-1.1,0-1.9-0.9-1.9-1.9V14.1c0-1,0.8-1.8,1.7-1.9c0.4,0,0.9-0.1,1.3-0.1 c7.4,0,13.4,6,13.4,13.4c0,0.4,0,0.9-0.1,1.3C33.7,27.8,32.9,28.6,31.9,28.6z M21.3,24.7H30c-0.4-4.6-4.1-8.3-8.7-8.7V24.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsactive);
export default __webpack_public_path__ + "static/media/Reports active.bf61924577a19fc1108ea7998a84ab5b.svg";
export { ForwardRef as ReactComponent };